var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLinks)?_c('ul',{staticClass:"event-links"},[_vm._l((_vm.links),function(link,index){return [(link.link_url && link.link_title)?_c('li',{key:index},[_c('cg-event-link',{attrs:{"link":link}})],1):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }